'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalHotel = function MapsLocalHotel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z' })
  );
};
MapsLocalHotel = (0, _pure2.default)(MapsLocalHotel);
MapsLocalHotel.displayName = 'MapsLocalHotel';
MapsLocalHotel.muiName = 'SvgIcon';

exports.default = MapsLocalHotel;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/maps/local-hotel.js
// module id = 2522
// module chunks = 0